import { createSelector } from 'reselect';

export const selectButton = state => state.onboardingButton;
export const selectButtonConfig = createSelector(selectButton, favorites => favorites.config);
export const selectButtonConfigViewData = createSelector(selectButtonConfig, config => config.viewData);
